import Vue from 'vue'
import App from './App.vue'
import router from '@/router/routes'
import store from './store'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import { messages } from './assets/translations/i18n'
import Notifications from 'vue-notification'
import VueGoogleCharts from 'vue-google-charts'
import { UserManager } from 'oidc-client-ts'
import './../node_modules/video.js/dist/video-js.css'
import './../node_modules/vue-slider-component/theme/default.css'

// plugins
/* eslint-disable */
import { setBrandGlobalColors } from '@/helpers/Utils'
import { vuetify } from './plugins/vuetify'
import { VEHICLE_STATUS_NAME } from './config/consts'
import { TRACKING_KEEP_ALIVE_TIME_INTERVAL } from '@/config/tackingConfig'
import { DictionaryApi, TrackingApi, AccountApi } from '@/api'

Vue.config.productionTip = false

Vue.mixin({
    methods: {
        hasAllRoles (requiredRoles) {
            const userRoles = this.$store.getters['authModule/getPermissions'].toString().split(',')
            if (userRoles.includes('1')) {
                return true
            } else if (Array.isArray(requiredRoles) && 'number' === typeof requiredRoles[0]) {
                return requiredRoles.every(v => userRoles.includes(v.toString()))
            } else if (Array.isArray(requiredRoles) && 'string' === typeof requiredRoles[0]) {
                const allRoles = this.$store.getters['dictionaryModule/getRoles']
                const mappedRoles = requiredRoles.map(v => {
                    const role = allRoles.find(role => role.key === v)
                    return role ? role.id.toString() : null
                })
                if (mappedRoles.length === 0 || mappedRoles == null) console.error('Misspelled permission name')
                return mappedRoles.every(v => userRoles.includes(v))
            }
        },
        hasAnyRole (requiredRoles) {
            const userRoles = this.$store.getters['authModule/getPermissions'].toString().split(',')
            if (userRoles.includes('1')) {
                return true
            } else if (Array.isArray(requiredRoles) && 'number' === typeof requiredRoles[0]) {
                return requiredRoles.some(v => userRoles.includes(v.toString()))
            } else if (Array.isArray(requiredRoles) && 'string' === typeof requiredRoles[0]) {
                const allRoles = this.$store.getters['dictionaryModule/getRoles']
                const mappedRoles = requiredRoles.map(v => {
                    const role = allRoles.find(role => role.key === v)
                    return role ? role.id.toString() : null
                })
                if (mappedRoles.length === 0 || mappedRoles == null) console.error('Misspelled permission name')
                return mappedRoles.some(v => userRoles.includes(v))
            }
        },
        async isAuthorized() {
            const session = await window.oidc.userManager.getUser();

            if (session) {
                return moment().isBefore(moment.unix(session.expires_at));
            }

            return false;
        },
        async getInitialData () {
            const loadingElement = document.getElementById('loading')
            if (loadingElement) loadingElement.remove();

            const isAuthorized = await this.isAuthorized();

            if (isAuthorized) {
                const [dictionaryResponse, userInfoResponse, userSettingsResponse] = await Promise.allSettled([
                    dictionaryApi.getDictionaries(),
                    accountApi.userInfo(),
                    accountApi.getUserSettings(),
                ])

                if (userInfoResponse.value.isSuccess) {
                    await this.$store.dispatch('authModule/setUserInfo', userInfoResponse.value.payload)
                    await this.$store.dispatch('brandModule/setBranding')
                }
                if (dictionaryResponse.value.isSuccess) {
                    await this.$store.dispatch('dictionaryModule/setDictionaries', dictionaryResponse.value.payload)
                }
                if (userSettingsResponse.value.isSuccess) {
                    await this.$store.dispatch('authModule/setUserSettings', userSettingsResponse.value.payload)
                }

                if (this.hasAllRoles(['DeviceView'])) {
                    const connection = this.$store.getters['signalR/getConnection']
                    const connectionDeviceCommand = this.$store.getters['signalRDeviceCommand/getConnection']
                    if (connection == null) {
                        await this.$store.dispatch('signalR/setSignalRConnection')
                    }
                    if (connectionDeviceCommand == null) {
                        await this.$store.dispatch('signalRDeviceCommand/setSignalRConnection')
                    }

                    setInterval(() => {
                        const connectionId = this.$store.getters['signalR/getConnectionId'];

                        if (connectionId != null && this.$store.getters["authModule/getIsAuthorized"]) {
                            trackingApi.keepAliveConnection(connectionId);
                        }
                    }, TRACKING_KEEP_ALIVE_TIME_INTERVAL)
                }
            }
        },
        checkLiveStreamingLicense () {
            const license = this.$store.getters['activeOrganizationData/getOrganizationLicenses'].find((elem) => {
                return 'LIVE_STREAMING' === elem.name
            })

            return !!license
        },
        checkRemotePlaybackStreamingLicense () {
            const license = this.$store.getters['activeOrganizationData/getOrganizationLicenses'].find((elem) => {
                return 'REMOTE_PLAYBACK_STREAMING' === elem.name
            })

            return !!license
        },

        checkMediaAccessibilityLicense(){
            const license = this.$store.getters['activeOrganizationData/getOrganizationLicenses'].find((elem) => {
                return 'MEDIA_ACCESSIBILITY' === elem.name
            })

            return !!license
        },

        checkAzureADLicence () {
            const license = this.$store.getters['activeOrganizationData/getOrganizationLicenses'].find((elem) => {
                return 'AZURE_AD_SINGLE_SIGN_ON' === elem.name
            })

            return !!license
        },
        mixinGetAzureADLicenseId () { return '2f59c8c3-1ad3-4e5c-ac88-a6a408581494' },
    }
})
Vue.use(Notifications)
Vue.use(VueI18n)
Vue.use(VueGoogleCharts)

export const i18n = new VueI18n({
    locale: 'en',
    messages
})


const dictionaryApi = new DictionaryApi()
const trackingApi = new TrackingApi()
const accountApi = new AccountApi()

//oidc setup
const currentHost = window.location.host;
let redirectUri;

if (currentHost.startsWith('www.')) {
    redirectUri = process.env.VUE_APP_OIDC_WWW_REDIRECT_URI;
} else {
    redirectUri = process.env.VUE_APP_OIDC_REDIRECT_URI;
}

window.oidc = {
    userManager: new UserManager({
        authority: process.env.VUE_APP_OIDC_AUTHORITY,
        client_id: process.env.VUE_APP_OIDC_CLIENT_ID,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'openid profile telematics.api offline_access',
        post_logout_redirect_uri: process.env.VUE_APP_OIDC_POST_LOGOUT_URI,
    })
}


new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
    async created() {
        window.addEventListener('beforeunload', () => {
            const connection = this.$store.getters['signalR/getConnection']
            if (connection != null) {
                store.dispatch('signalR/clearSignalRConnection')
            }

            const connectionDeviceCommand = this.$store.getters['signalRDeviceCommand/getConnection']
            if (connectionDeviceCommand != null) {
                store.dispatch('signalRDeviceCommand/clearSignalRConnection')
            }
        }, false)
    },
}).$mount('#app')

